/**
 * @desc undefined
 */
import { PricingMethodEntity } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryPricingMethodListParameter = {
  search?: string

  supportTradeType?: string

  kindCode?: string
}

const method = 'GET'
const url = '/trade/pricingMethod/list'

export const queryPricingMethodListApi = (
  params?: QueryPricingMethodListParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<PricingMethodEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryPricingMethodListApi.method = method
queryPricingMethodListApi.url = url
